import { render, staticRenderFns } from "./adminsidenav.vue?vue&type=template&id=f121810e&scoped=true"
import script from "./adminsidenav.vue?vue&type=script&lang=js"
export * from "./adminsidenav.vue?vue&type=script&lang=js"
import style0 from "./adminsidenav.vue?vue&type=style&index=0&id=f121810e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f121810e",
  null
  
)

export default component.exports